import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/home/Home'
import Apartments from '../components/apartments/Apartments'
import digitalresources from '../components/digitalResources/digitalResources'
import childCarePrograms from '../components/childCarePrograms/childCarePrograms'
import parkAccessibility from '../components/parksAccessibility/parksAccessibility'
import foodResources from '../components/foodResources/foodResources'
import map from '../components/strapi/map'
import Projects from '../components/projects/Projects'
import Project from '../components/projects/Project'
import polling from '../components/pollingPlaces/polling'
import Search from '../components/projects/Search'
import NotFound from '../components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: { title: 'Home' },
      component: Home
    },
    {
      path: '/apartments',
      name: 'Apartments',
      meta: { title: 'Apartments and Condos' },
      component: Apartments
    },
    {
      path: '/digitalresources',
      name: 'digitalResources',
      meta: { title: 'Digital Resources' },
      component: digitalresources
    },
    {
      path: '/childcareprograms',
      name: 'childcareprograms',
      meta: { title: 'Child Care Availability' },
      component: childCarePrograms
    },
    {
      path: '/parkaccessibility',
      name: 'parkaccessibility',
      meta: { title: 'Park Amenities' },
      component: parkAccessibility
    },
    {
      path: '/foodresources',
      name: 'foodresources',
      meta: { title: 'Food Assistance Resources' },
      component: foodResources
    },
    {
      path: '/map/:slug',
      name: 'map',
      meta: { title: 'Map' },
      component: map
    },
    {
      path: '/polling',
      name: 'polling',
      meta: { title: 'Polling Place Locator' },
      component: polling
    },
    {
      path: '/projects',
      name: 'Projects',
      meta: { title: 'Infrastructure Projects' },
      component: Projects,
      props: (route) => ({
        queryStatus: route.query.status,
        querySubStatus: route.query.subStatus,
        queryProjectType: route.query.type
      })
    },
    {
      path: '/dailywork',
      name: 'DailyWork',
      meta: { title: 'Daily Infrastructure Work' },
      component: Projects,
      props: (route) => ({
        queryStatus: route.query.status,
        querySubStatus: route.query.subStatus,
        queryProjectType: route.query.type
      })
    },
    {
      path: '/projects/:id',
      name: 'Project',
      meta: { title: 'Project permits' },
      component: Project
    },
    {
      path: '/search/',
      name: 'Projects Search',
      meta: { title: 'Projects search' },
      component: Search
    },
    {
      path: '*',
      name: '404',
      meta: { title: 'Page not found' },
      component: NotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js